import Consts from "Interfaces/Consts";
import { FormFieldProps, FormTypeComponentProps as Props } from './ContactUs.Interfaces';
import FormField from './ContactUs_FormField';

const ContactUsSideLayoutForm: React.FC<Props> = ({
    variableInputs,
    hideName,
    hidePhone,
    componentId,
    inputValues,
    changeInput,
    validateInput,
    errors,
    isVariable1Req,
    isVariable2Req
}) => {
    // Returns an object with all the input's needed attributes and props
    const getFormFieldProps = (
        keyName: string,
        name: string,
        inputType: 'tel' | 'text' | 'email' | 'textarea',
        isRequired = true,
        classForInput = '',
    ): FormFieldProps => {
        return {
            label: Consts[keyName],
            inputValue: inputValues[keyName],
            error: errors[keyName],
            onChange: (event) => changeInput(event, keyName),
            onBlur: (event) => validateInput(event, keyName),
            name,
            componentId,
            inputType,
            isRequired,
            classForInput,
        }
    }

    const hasVariable1 = variableInputs.length > 0 && !!variableInputs[0];
    const hasVariable2 = variableInputs.length > 1 && !!variableInputs[1];
    const hasBothVariables = (hasVariable1 && hasVariable2);
    const classForVariableInput = hasBothVariables ? 'half-size' : '';

    const nameInputProps = getFormFieldProps('name', 'Name', 'text', true);
    const phoneInputProps = getFormFieldProps('phone', 'Phone', 'tel', true);
    const emailInputProps = getFormFieldProps('email', 'Email', 'email', true);
    const messageInputProps = getFormFieldProps('message', 'Message', 'textarea', true, 'col-md-12');
    const variable1InputProps = hasVariable1 ? getFormFieldProps('variable1', 'Variable1', 'text', isVariable1Req, classForVariableInput) : null;
    const variable2InputProps = hasVariable2 ? getFormFieldProps('variable2', 'Variable2', 'text', isVariable2Req, classForVariableInput) : null;

    return (
        <div className="horizontal-form">

            {!hideName && <InputField {...nameInputProps} /> }

            <InputField {...emailInputProps} />

            {!hidePhone && <InputField {...phoneInputProps} /> }

            {
                (hasVariable1 || hasVariable2) &&

                <div className={hasBothVariables ? "one-line" : ""}>
                    {
                        hasVariable1 &&
                        <InputField {...variable1InputProps} isVariable={true} label={variableInputs[0]} />
                    }
                    {
                        hasVariable2 &&
                        <InputField {...variable2InputProps} isVariable={true} label={variableInputs[1]} />
                    }
                </div>
            }

            <InputField {...messageInputProps} />

            <div className="mzFormGroup">
                <div className='requiredMessage'>{Consts.requiredMessage}</div>
            </div>
        </div>
    )
}

const InputField = (props: FormFieldProps) => {
    return <FormField {...props}>
        
        <FormField.Error />

        <FormField.Label className='horizontal-label' />

        {
            props.inputType == 'textarea' ?
                <FormField.TextArea className="input-border" /> :
                <FormField.Input className="input-border dont-stretch" />
        }
    </FormField>
}

export default ContactUsSideLayoutForm;